import Config from '../Config';
import { RestService } from './RestService';

export const ReasonService = {
    getReasonByType: async function(type){
        return RestService.get(`${Config.get_reason_by_type}type=${type}`, {})
        .then(response => response.json());
    },
    createReason: async function(type, reason){
        return RestService.post(`${Config.create_reason}type=${type}&reason=${reason}`, {}, undefined);
    },
    removeReason: async function(type, reason){
        return RestService.post(`${Config.remove_reason}type=${type}&reason=${reason}`, {}, undefined);
    }
};